"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchTrustedLoginChallengeSession = void 0;
const fetchTrustedLoginChallengeSession = (api, progressId, url) => api.GET(url, {
    headers: {
        progressId,
    },
});
exports.fetchTrustedLoginChallengeSession = fetchTrustedLoginChallengeSession;
//# sourceMappingURL=resolver.js.map